export const environment = {
  aad_tennant_id: 'e09ff9bc-6129-4d88-be42-f65f0d4b0da2',
  aad_app_id: 'f238ddd3-7e8f-4931-9d53-ccd3a659b001',
  aad_tennant_name: 'emlportal.onmicrosoft.com',
  aad_signin_flow: 'B2C_1A_BETA_SIGNIN_MFA_ENABLED_WITH_EXCLUSIONS',
  aad_signup_flow: 'B2C_1A_signup_invitation',
  aad_forget_password_flow: 'B2C_1A_beta_password_reset',
  eml_sdk_api_url: 'https://cmp-beta-api.emlpayments.com/mgmt/v1/',
  eml_sdk_api_key: '88042c2ebac643f0a2e25b70691801d2',
  eml_static_bucket_url: 'https://emlbetastaticbucket.blob.core.windows.net/images/',
  postLogoutRedirectUri: '/',
  redirectUri: '/',
  production: false,
  transaction_statement_month_limit: 18,
  confirm_accept_hide_login_progams: ['payability'],
  create_batch_cardholders_template: 'https://emlbetastaticbucket.blob.core.windows.net/templates/cardholder_batch_template.csv',
  create_batch_cardholders_template_without_PII: 'https://emlbetastaticbucket.blob.core.windows.net/templates/cardholder_batch_template_without_PII.csv',
  card_art_base_url: 'https://emlbetapayments.blob.core.windows.net/cardart/',
  apple_pay_partner_id: 'ORG-f35a3dbb-723d-4980-bee8-525b7118bbb1',
  apple_pay_domain: 'https://apple-pay-cert.apple.com',
  google_pay_integrator_id: 'BCR2DN4TU7XOLOJB',
  google_pay_is_test_environment: true,
};
// This is not for use in prod due to performance impact
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
